import React, { useState, useEffect } from 'react';
import { HTTPService } from '../services/httpService';

const API = new HTTPService();

const TransferInterface = ({ 
  request, 
  currentInstaller, 
  onTransfer, 
  onCancel,
  show = false 
}) => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && currentInstaller) {
      fetchTeamMembers();
    }
  }, [show, currentInstaller]);

  const fetchTeamMembers = async () => {
    setLoading(true);
    try {
      const { data: members } = await API.get(`/installerGroup/${currentInstaller.installer_id}`);
      console.log('Fetched team members:', members);
      setTeamMembers(members || []);
    } catch (err) {
      console.error('Failed to fetch team members:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleTransfer = async () => {
    if (!selectedMember) return;
    
    await onTransfer({
      requestId: request.requestId,
      fromInstaller: currentInstaller.installer_id,
      toInstaller: selectedMember
    });
    
    setSelectedMember('');
  };

  return (
    <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" style={{backgroundColor: show ? 'rgba(0,0,0,0.5)' : 'transparent'}}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Transfer Job to Other Specialst</h5>
            <button type="button" className="close" onClick={onCancel}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <strong>Job:</strong> {request.vehicleYear} {request.vehicleMake} {request.vehicleModel}
              <br />
              <small className="text-muted">From: {request.dealerName}</small>
            </div>
            
            {loading ? (
              <div className="text-center py-3">
                <div className="spinner-border spinner-border-sm" role="status"></div>
                <span className="ml-2">Loading specialists...</span>
              </div>
            ) : teamMembers.length === 0 ? (
              <div className="alert alert-info">No specialists available for transfer.</div>
            ) : (
              <div>
                <label>Select specialist:</label>
                <select 
                  className="form-control" 
                  value={selectedMember} 
                  onChange={(e) => setSelectedMember(e.target.value)}
                >
                  <option value="">Choose a specialist...</option>
                  {teamMembers.map((member) => (
                    <option key={member.Installer_id} value={member.Installer_id}>
                      {member.Installer_Name} 
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onCancel}>
              Cancel
            </button>
            <button 
              type="button"
              className="btn btn-warning" 
              onClick={handleTransfer}
              disabled={!selectedMember || loading}
            >
              Transfer Job
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransferInterface;
